module.exports = __webpack_public_path__ + "static/dp-newspaper-interior-page-35740de865595804bc71402c4c0f93f6.jpg";